import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { DialogTitle, Typography, IconButton } from '@material-ui/core';
import { CloseRounded as CloseIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import ModalStore from '../../../stores/ModalStore';

const modalHeaderStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#0086FF',
    color: '#fff',
    '& h6': {
      fontSize: '21px',
    },
    display: 'flex',
    justifyContent: 'space-between',
  },
  closeButton: {
    color: '#fff',
    padding: 0,
  },
}));

function ModalHeader(props) {
  const {
    children,
    modalStore: { closeModal },
  } = props;
  const classes = modalHeaderStyles();

  return (
    <DialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={() => closeModal()}
        disableRipple
      >
        <CloseIcon fontSize="large" />
      </IconButton>
    </DialogTitle>
  );
}

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  modalStore: PropTypes.instanceOf(ModalStore).isRequired,
};

export default inject('modalStore')(observer(ModalHeader));
